import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = { class: "pa-1 name-wrapper d-flex align-center" }
const _hoisted_3 = { class: "icon mr-2" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "d-flex justify-center align-center" }
const _hoisted_6 = {
  key: 0,
  class: "badge d-flex justify-center align-center mr-2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_list = _resolveComponent("v-list")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.children, (c) => {
      return (_openBlock(), _createElementBlock("div", {
        key: c.childId
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("img", {
              src: _ctx.resolveChildImageUrl(c.imageUrl) || 'https://via.placeholder.com/240x180?text=Sample+Image+1'
            }, null, 8, _hoisted_4)
          ]),
          _createElementVNode("h5", null, _toDisplayString(c.lastName) + _toDisplayString(c.firstName), 1)
        ]),
        _createVNode(_component_v_list, { density: "compact" }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item, index) => {
              return (_openBlock(), _createElementBlock(_Fragment, {
                key: item.title
              }, [
                _createVNode(_component_v_list_item, {
                  onClick: ($event: any) => (_ctx.to( item.path, item.to, c.childId, c.lastName + c.firstName ))
                }, {
                  append: _withCtx(() => [
                    _createElementVNode("div", _hoisted_5, [
                      (item?.badgeNum >= 1)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(item.badgeNum ?? 0), 1))
                        : _createCommentVNode("", true),
                      _createVNode(_component_v_icon, null, {
                        default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                          _createTextVNode("mdi-chevron-right", -1)
                        ]))]),
                        _: 1
                      })
                    ])
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_v_list_item_title, {
                      textContent: _toDisplayString(item.title)
                    }, null, 8, ["textContent"])
                  ]),
                  _: 2
                }, 1032, ["onClick"]),
                _createVNode(_component_v_divider)
              ], 64))
            }), 128))
          ]),
          _: 2
        }, 1024)
      ]))
    }), 128))
  ]))
}